import { useEffect, useRef } from "react"

import {
  metricViewerEventBus,
  type MetricViewerEventPayloads,
  type MetricViewerEventType,
} from "../utils/eventBus"

type EventListener<T extends MetricViewerEventType> = (
  payload: MetricViewerEventPayloads[T],
) => void

/**
 * Custom hook for subscribing to event bus events
 * Automatically handles cleanup when component unmounts
 */
export function useEventBus<T extends MetricViewerEventType>(
  eventType: T,
  listener: EventListener<T>,
): void {
  const listenerRef = useRef<EventListener<T>>(listener)

  useEffect(() => {
    listenerRef.current = listener
  }, [listener])

  useEffect(() => {
    const unsubscribe = metricViewerEventBus.subscribe(eventType, (payload) => {
      listenerRef.current(payload)
    })
    return unsubscribe
  }, [eventType])
}
